import styled from "styled-components";

const WellnessProfessionalsStyle = styled.div`

.VideoSliderWrap {
    max-width: 930px;
    width: 100%;
    padding: 0 15px 70px;
    position: relative;
    z-index: 2;

    @media only screen and (max-width: 991px) {
        max-width: 740px;
    }

    @media only screen and (max-width: 767px) {
        max-width: 540px;
        margin-top: 20px;
    }

    @media only screen and (max-width: 575px) {
        max-width: 450px;
    }

    @media only screen and (max-width: 480px) {
        max-width: 330px;
    }

    @media only screen and (max-width: 360px) {
        max-width: 300px;
    }

    .slick-slider {
        width: 100%;
    
        .slick-slide {
            &>div {
                &>div {
                    display: flex !important;
                }
            }
            .video_sec { 
                display: flex !important;
                box-shadow: 0 0 12px rgb(0 0 0 / 50%);  
                width: 100% !important;
                height: 506px;
                margin: 0 auto;
                position: relative;
                z-index: 1;
                overflow: hidden;
                background-color: #000;

                @media (max-width: 991px){
                    height: 399px;
                }
                
                @media (max-width: 767px){
                    height: 288px;
                    /* height: auto; */
                    box-shadow: unset;  
                }

                @media (max-width: 575px){
                    height: 236px;
                }

                @media (max-width: 480px){
                    height: 170px;
                }

                @media (max-width: 360px){
                    height: 153px;
                }

                iframe { 
                    position: absolute;
                    top: 50%;
                    transform: translate(-50% , -50%);
                    left: 50%;
                    width: 100%;
                    height: 100%;   
                }
                & > img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover; 
                    -webkit-animation: seconds 3.0s forwards;
                    -webkit-animation-iteration-count: 1;
                    -webkit-animation-delay: 2s;
                    animation: seconds 1.0s forwards;
                    animation-iteration-count: 1;
                    animation-delay: 2s;
                    position: relative;
                }
            }     
        }

        .slick-dots {
            display: flex !important;
            align-items: center;
            justify-content: center;

            li {
                height: auto;
                width: auto;

                button {
                    padding: 0;
                    background-color: transparent;
                    border-radius: 100%;
                    height: 10px;
                    width: 10px;
                    transition: all ease-in-out 0.3s;
                    border: 1px solid #621d87;

                    &::before {
                        display: none;
                    }
                }
                &.slick-active {
                    button {
                        background-color: #621d87;
                    }
                }
            }
        }
    }
}



    @-webkit-keyframes seconds {
        0% {
            opacity: 1;
            visibility:visible;
        }
        100% {
            opacity: 0;
            visibility:hidden;
        }
        }
        @keyframes seconds {
            0% {
            opacity: 1;
            visibility:visible;
        }
        100% {
            opacity: 0;
            visibility:hidden;
        }
     }
    padding-top: 200px;
    position: relative;
    overflow-y: hidden;
    @media (max-width: 767px){
        padding-top: 130px;
    } 
    
    .main_wellnessProfessionals_section{ 
        display: flex;
        flex-direction: column;
        align-items: center; 
        .title_sections {
            text-align: center;
            position: relative;
            z-index: 1;
            padding: 0 15px;
            h2 {
            background: linear-gradient(90deg,#fbd709 0%,#e94f24 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            }
            h3{
                font-size: 38px;
                    line-height: 38px;
                    color: #000000;
                    font-family: var(--common-font);
                    text-align: center;
                    margin-bottom: 25px;
                    @media (max-width: 1280px){ 
                    font-size: 36px;
                    line-height: normal;
                    }
                @media (max-width: 1199.98px){ 
                font-size: 30px; 
                }
                @media (max-width: 991px){ 
                font-size: 26px; 
                }
                @media (max-width: 767px){
                    font-size: 24px;
                    margin-bottom: 0;
                }
            }
        }
        .text_container {  
            width: 100%;   
            position: relative;
            z-index: 1;
                .container{
                    .d-flex.row {
                        gap: 100px;
                        background: linear-gradient(90deg, #e0e4e6db 0%, #c0cbd1cf 100%); 
                        & ::after,& ::before{
                            display: none;
                        }
                        @media (max-width: 1200px){
                            gap: 20px;
                        }
                        @media (max-width: 1199.98px){
                            gap: 0px;
                    }
                    @media (max-width: 1024px){
                      flex-wrap: wrap;
                      .col-md-6{
                        max-width: 100%;
                        flex: 100%;
                      }
                    }
                    }
                }
             p {
                font-size: 25px;
                color: #000000;
                font-family: var(--common-font);
                @media (max-width: 767px){
                    font-size: 22px;
                    line-height: normal;
                    text-align: center;
                }
            }
            .first_content_section {  
                    padding-top: 20px;
                & > p{
                    margin-right: 50px;
                    @media (max-width: 1199.98px){
                        margin-right: 0;
                    }
                } 
                .image_text_one{
                    gap: 15px;
                    margin: 30px 0; 
                    &>div{
                        flex: 1;
                        @media (max-width: 767px){
                            flex: 100%;
                            max-width: 100%;
                    }
                    } 
                }
                .image_text_two {
                    gap: 10px;
                   &>div {
                        flex: 1;
                        @media (max-width: 767px){
                            flex: 100%;
                            max-width: 100%; 
                    }
                    }
                    .image {
                        max-width: 210px;
                    }
                    @media (max-width: 767px){ flex-direction: column-reverse;}
                    @media (max-width: 767px){
                        .content{
                                margin: 30px 0;
                            }
                        }
                }
                .image_text_one, .image_text_two {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    @media (max-width: 767px){
                      flex-wrap: wrap;
                    }
                    .image{
                        img {
                            max-width: 100%;width: 100%;
                        }
                    }
                }
            }
          
        }

        .message_tip {
            position: relative;
            margin-bottom: 40px;
            @media (max-width: 1024px){
                margin-bottom: 60px;
            }
            .image {
                    position: relative;
                    margin-bottom: 100px; 
                    &:before {
                        content: "";
                        position: absolute;
                        top: calc(100% - 5px);
                        right: 220px;
                        width: 0;
                        height: 0;
                        border-top: 52px solid #e94f24;
                        border-right: 52px solid transparent;
                        z-index: 99;
                        @media (max-width: 767px){
                         right: 90px;
                        }
                        }
                    img {
                        width: 100%; 
                       
                    }
                    @media (max-width: 1024px){
                            max-width: 740px;
                            margin: 0 auto;
                            display: block;
                        }
                        @media (max-width: 991px){
                            max-width: 600px; 
                        }
                        @media (max-width: 767px){
                            max-width: 350px;
                        }
                       
                }
            .content-quote {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                max-width: 520px;
                text-align: center;  
                @media (max-width: 1280px){
                    padding: 10px;
                }
                @media (max-width: 767px){
                max-width: 290px;
                }
                P{
                    color: #fff;
                    @media (max-width: 767px){
                        font-size: 16px;
                        line-height: normal;
                        } 
                }
                span{
                    font-size: 25px;
                    color: #fff;
                    font-family: var(--common-font);
                    @media (max-width: 767px){
                        font-size: 16px;
                }  
                } 
                
            }
        } 
            .button_sections {
                margin: 80px 0;
                display: flex;
                gap: 20px;
                justify-content: center;
                @media (max-width: 1024px){
                    margin: 40px 0;
                }
                @media (max-width: 767px){
                    margin: 10px 0;
                    flex-wrap: wrap;
                }
                button {
                    background-color: var(--green);
                    border-radius: 30px;
                    // font-size: 32px;
                    font-size: 20px;
                    color: #ffffff;
                    font-weight: bold;
                    font-family: "Exo";
                    border: none;
                    text-align: center;
                    a{
                        text-decoration: none;
                        font-size: 20px;
                        font-family: var(--exo);
                    }
                    &:hover{
                        a{ color:#fff}
                        }
                    @media (max-width: 1024px){
                        font-size: 28px;
                    }
                    @media (max-width: 767px){
                        font-size: 20px;
                    }
                    &.join_as_button a {
                        text-decoration: unset;
                        color: #ffffff;
                    }
                }
             }
    }
    a{
        color: #fff;
    }
`;

export default WellnessProfessionalsStyle;